import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=100aabba&"
import script from "./notifications.ts?vue&type=script&lang=js&"
export * from "./notifications.ts?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&id=100aabba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports